var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSelectedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 24,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C1A37",
    strokeWidth: 2,
    d: "M7 12.267 9.895 16 18 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectedWhite);
export default __webpack_public_path__ + "static/media/ic_selected_white.a7e88bfcb751a47aa57c6aad2d44ceb2.svg";
export { ForwardRef as ReactComponent };